import React, { useContext, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { omit } from 'lodash'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { PharmaciesDetailsFiltersContext } from '../../../../context/PharmaciesDetailsFiltersContext'
import { STATUS_DELIVERED } from '../../../../types/Order'

const GET_DATA = gql`
  query PharmaciesOrdersFinished($filters: JSON) {
    ordersAggs(
      size: 0,
      filters: $filters,
      query: {
        bool: {
          filter: [
            {
              term: {
                status_translate_keyword: "${STATUS_DELIVERED}"
              }
            }
          ]
        }
      },
      aggs: {
        total: {
          value_count: {
            field: "id.keyword"
          }
        }
      }
    ) {
      aggregations
    }
  }
`

const PharmaciesOrdersFinished = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters: omit(filters, 'orderTotals') }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Quantidade total de pedidos entregues " number={data.ordersAggs.aggregations.total.value} color={Colors.green} />
  )
}

export default PharmaciesOrdersFinished
